import {messages} from '@smartmixin/i18n';
import {EnvelopeSimple} from '@phosphor-icons/react';
import {Box, Typography} from '@mui/material';
import {useIntl} from 'react-intl';
import {Button, Surface} from '../../components/ui';
import {SUPPORT_EMAIL} from '../constants';

type HelpEscalationProps = {
  articleTitle?: string;
};

// Last stop on every article: self-serve failed, make contact easy.
const HelpEscalation = ({articleTitle}: HelpEscalationProps) => {
  const {formatMessage} = useIntl();

  const subject = articleTitle
    ? formatMessage(messages.helpCenter.supportEmailSubjectTopic, {
        topic: articleTitle,
      })
    : formatMessage(messages.helpCenter.supportEmailSubject);
  const mailto = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;

  return (
    <Surface
      sx={{
        p: 2.5,
        mt: 2,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
      }}>
      <Box sx={{minWidth: 0, flex: '1 1 240px'}}>
        <Typography variant="title" component="p" sx={{color: 'text.primary'}}>
          {formatMessage(messages.helpCenter.stillNeedHelp)}
        </Typography>
        <Typography variant="body2" sx={{color: 'text.secondary', mt: 0.25}}>
          {formatMessage(messages.helpCenter.stillNeedHelpDescription)}
        </Typography>
      </Box>
      <Button
        variant="secondary"
        startIcon={<EnvelopeSimple aria-hidden />}
        href={mailto}>
        {formatMessage(messages.helpCenter.contactSupport)}
      </Button>
    </Surface>
  );
};

export default HelpEscalation;
